import * as React from 'react';
import { Fragment, useState } from 'react';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import Tooltip from '@material-ui/core/Tooltip';
import { IconButton, Badge } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';

const useStyles = makeStyles(theme => ({
    icon: { minWidth: theme.spacing(5) },
    sidebarIsOpen: {
        '& a': {
            paddingLeft: theme.spacing(4),
            transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
        },
    },
    sidebarIsClosed: {
        '& a': {
            paddingLeft: theme.spacing(0),
            transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
        },
    },
}));

const SubMenu = ({
    sidebarIsOpen,
    name,
    icon,
    children,
    dense,
    badgeContent,
    defaultExpanded,
    routePath
}) => {
    const translate = useTranslate();
    const classes = useStyles();
    const [open, setOpen] = useState(defaultExpanded);
    let routePaths = children.filter(path => !!path).map((path) => path.props.to);

    const sectionHandler = () => {
        if (open && routePaths.includes(routePath)) {
            setOpen(true)
        } else {
            setOpen(!open)
        }
    }

    const header = (sidebarIsOpen ?
        <Tooltip title={"List of authorized users with permit details"} placement="bottom-end">
        <MenuItem dense={dense} button onClick={() => sectionHandler()} className="RaMenuItemLink-default">
            <ListItemIcon className={classes.icon}>
                {open ? <ExpandMore /> : icon}
            </ListItemIcon>
            <Typography variant="inherit" color="textSecondary">
                {translate(name)}
            </Typography>
        </MenuItem>
        </Tooltip>
        :
        <IconButton onClick={() => sectionHandler()}>
            {open ? <ExpandMore /> : icon}
        </IconButton>
    );

    return (
        <Fragment>
            {sidebarIsOpen || open ? (
                <Badge color="error" badgeContent={badgeContent} classes={{ root: "navMenuLinkBadgeContainer", badge: "navMenuLinkBadge" }}>{header}</Badge>
            ) : (
                <Tooltip title={translate(name)} placement="right">
                    {header}
                </Tooltip>
            )}
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                    dense={dense}
                    component="div"
                    disablePadding
                    className={
                        sidebarIsOpen
                            ? classes.sidebarIsOpen
                            : classes.sidebarIsClosed
                    }
                >
                    {children}
                </List>
            </Collapse>
        </Fragment>
    );
};

export default SubMenu;